<template>
   
    <div class="container mt-2 justify-content-center">
     <div class="row ">
      <div class="col-6 mt-3">
           <!-- Button trigger modal -->
<button v-if="this.$store.state.user.positionID==1 || this.$store.state.user.positionID==3 || this.$store.state.user.positionID==4" type="button" @click="addOrder()" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#exampleModal">
  <i class='bx bx-plus'></i>
</button>


<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
       
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3 mt-3">
  
  <input type="text" class="form-control"   placeholder="ბრძანების სახელი" v-model="orderName">
 
</div>
<div class="mb-3">

  <input type="text" class="form-control"  placeholder="ბრძანების ნომერი" v-model="orderNumber">
</div>

  <div class="mb-3">

    <input type="date" class="form-control" v-model="order_date"/>
</div>
<div class="mb-3">

<input type="file" class="form-control" @change="getOrder"/>
</div>
        
      </div>
      <div class="modal-footer">
       
        <button  v-if="!isReadyForEdit" type="button" class="btn btn-primary" @click="saveOrder()">შენახვა</button>
        <button v-else type="button" class="btn btn-primary" @click="goEditOrder(editedOrderID)">რედაქტირება</button>
      </div>
    </div>
  </div>
</div>
    
        </div>
             <div class="col-12 mt-3">
 
              <div class="row">
                  <div class="col-4 mb-2 d-grid" v-for="years of orderYears">
                    <button @click="showOrders(years.ordersYears)" class="btn btn-success">{{ years.ordersYears }}</button>
                  </div>
              </div>


                 <table class="table" v-if="orders.length>0">
   <thead>
     <tr>
        
       <th scope="col"> ბრძანები სახელი</th>
       <th scope="col">ბრძანების ნომერი</th>
       <th scope="col">ბრძანების თარიღი</th>
       <th scope="col">მიმაგრებული ფაილი</th>
      
 
     </tr>
   </thead>
   <tbody>
     
     <tr v-for="order in orders" :key="order.orderID">
       
       <td  scope="row">{{ order.orderName }}</td>
       <td>{{order.orderNumber}}</td>
       <td>{{ order.order_date }}</td>
       <td><a :href="'https://api.ugcollege.ug.edu.ge/storage/orders/'+order.orderFile" target="_blank">მიმაგრებული ფაილი</a></td>
       <td><button v-if="this.$store.state.user.positionID==1" data-bs-toggle="modal" data-bs-target="#exampleModal" type="button" @click="editOrder(order)" class="btn btn-outline-success"><i class='bx bxs-edit-alt'></i></button> </td>
       <td> <button v-if="this.$store.state.user.positionID==1" type="button" @click="deleteOrder(order.orderID)" class="btn btn-outline-success"><i class='bx bx-x'></i></button></td>
    
     </tr>
     
   
 
   </tbody>
 </table>
             </div>
 
     </div>
    </div>
  
 
 </template>

 <script>
 import HttpRequests from '../httpRequests/httpRequests'
 const httpRequests=new HttpRequests()
  export default{

    data(){
      return{
        orderName:null,
        orderNumber:null,
        order_date:null,
        orderFile:null,
        orders:[],
        isReadyForEdit:false,
        editedOrderID:0,
        orderYears:[]
      }
    },
    mounted(){


      httpRequests.getOrdersYears().then(response=>{
        this.orderYears=response.data
      })

       


    },
    methods:{

      showOrders(year){
        httpRequests.getOrder(year).then(response=>{
        this.orders=response.data
      })

      },


      getOrder(e){
        this.orderFile=e.target.files[0]
      },
      saveOrder(){
        let formData=new FormData()

        formData.append('orderName',this.orderName)
        formData.append('orderNumber',this.orderNumber)
        formData.append('order_date',this.order_date)
        formData.append('orderFile',this.orderFile)

          httpRequests.saveOrder(formData).then(()=>{
            location.reload()
          })


      },
      editOrder(order){

        this.isReadyForEdit=true
        this.editedOrderID=order.orderID
        this.orderName=order.orderName
        this.orderNumber=order.orderNumber
        this.order_date=order.order_date

      },
      addOrder(){
        this.isReadyForEdit=false
        this.editedOrderID=0
        this.orderName=null
        this.orderNumber=null
        this.order_date=null
      },
      goEditOrder(orderID){

        let formData=new FormData()

      formData.append('orderName',this.orderName)
      formData.append('orderNumber',this.orderNumber)
      formData.append('order_date',this.order_date)
      formData.append('orderFile',this.orderFile)
      formData.append('orderID',orderID)

        httpRequests.goEditOrder(formData).then(()=>{
          location.reload()
        })

      },
      deleteOrder(orderID){
        if(confirm("ნამდვილად გსურთ წაშლა?")){
        httpRequests.deleteOrder(orderID).then(()=>{
          location.reload()
        })
      }
      }
    }
  }

</script>